import React from 'react';
import HeaderOne from '../../Header/HeaderOne';
import FooterOne from '../../Footer/FooterOne';
import BannerOne from '../../HomeOne/BannerOne/BannerOne';
import Service from '../../HomeOne/Service/Service';
import AboutOne from '../../HomeOne/AboutOne/AboutOne';
import Choose from '../../HomeOne/Choose/Choose';
import Testimonial from '../../HomeOne/Testimonial/Testimonial';
import Brand from '../../HomeOne/Brand/Brand';
import Blog from '../../HomeOne/Blog/Blog';
import { pageTitle } from '../../PageTitle';


const HomeOne = () => {
    pageTitle('MaticResearch');
    return (
        <>
            <HeaderOne></HeaderOne>
            <BannerOne></BannerOne>
            <Service></Service>
            <AboutOne></AboutOne>
            <Testimonial></Testimonial>
            <Choose></Choose>
            
            <Brand></Brand>
            {/* <Blog></Blog> */}
            <FooterOne></FooterOne>
        </>
    );
};

export default HomeOne;